/**
 * Decider for "single_experiment" and "multivariate" policies (i.e. those with only one experiment in the layer)
 * @module
 */
var deciderFns = require('core/decision/decider_fns');
var DecisionError = require('core/decision/error').DecisionError;

/**
 * @constant
 * @type {string}
 */
var SINGLE_EXPERIMENT = 'single_experiment';

/**
 * @constant
 * @type {string}
 */
var MULTIVARIATE = 'multivariate';

var pluginDeciderMulti: Decider = {
  /**
   * Select the experiment the visitor should be bucketed into. In this case it is the only single experiment
   * @param {Layer} layer
   * @param {string[]} audienceIds Optionally, audienceIds can be used to decide
   * @param {string} bucketingId
   * @throws {DecisionError} If no eligible experiments in layer
   * @returns {Experiment}
   */
  selectExperiment: function(layer:Layer, audienceIds:string[], bucketingId:string): Experiment {
    if (layer.experiments.length < 1) {
      throw new DecisionError('Unable to find experiment to bucket user into');
    }

    var selectedExperiment = layer.experiments[0];
    if (!deciderFns.isValidExperiment(audienceIds, selectedExperiment)) {
      throw new DecisionError('Audience conditions failed for experiment: "' + selectedExperiment.id + '".');
    }

    return selectedExperiment;
  },
};

module.exports = function(PluginManager) {
  PluginManager.registerDecider(SINGLE_EXPERIMENT, pluginDeciderMulti);
  PluginManager.registerDecider(MULTIVARIATE, pluginDeciderMulti);
};

if (__TEST__) {
  module.exports.plugin = pluginDeciderMulti;
}
